import { RECORD_QUERY_DEFAULT_LIMIT } from '@ofmos/shared/record-query';
import { toggleKey } from '../../record/useLocalToggle';

/**
 * ROWS PER PAGE: the choices, and the one key this browser remembers them under
 * (`table-completion.md` D4).
 *
 * DECLARATIONS ONLY, and that split is a decision rather than a detail. The reading and
 * the writing live in `app/record/useLocalToggle.ts`, beside the boolean form and beside
 * `toggleKey`, because that file already owns per-browser preference and its key
 * convention. A second implementation of `localStorage` reading, inside a table module,
 * next to a shipped one, is exactly what putting the hook here would have bought.
 *
 * WHY THESE FOUR VALUES: they are this repository's own numbers rather than a reference
 * product's. The DEFAULT is `RECORD_QUERY_DEFAULT_LIMIT` itself, imported, because D2
 * leaves exactly one page-size constant for a page to be sized by. 25 and 200 are
 * LITERALS on purpose, even though the board's `COLUMN_PAGE_SIZE` is 25 and
 * `GROUP_MAX_LIMIT` is 200: importing either would tie a menu of reading preferences to a
 * board page size or to a cap on group headers, so that changing one would silently
 * change the other. Two numbers that happen to be 25 are not one number.
 *
 * WHY ONE KEY AND NOT ONE PER LIST: a reader cannot keep Agencies at 200 and Customers at
 * 50. The alternative is unbounded local storage for a value nobody asked to vary, and a
 * menu whose own sentence ("Rows per page") would stop being true. Reversible without a
 * migration, because the key can grow a suffix.
 */
export const PAGE_SIZE_CHOICES: readonly number[] = [25, RECORD_QUERY_DEFAULT_LIMIT, 100, 200];

/**
 * ONE key for every list. `toggleKey`'s convention, so everything this browser remembers
 * about looking sorts together under one prefix.
 *
 * A stored value that is not in `PAGE_SIZE_CHOICES` falls back to
 * `RECORD_QUERY_DEFAULT_LIMIT` on `viewState.ts`'s rule ("A VIEW NEVER ERRORS. IT
 * DEGRADES, AND SAYS SO") - with the "says so" arm deliberately absent, because there is
 * nothing to say: the menu then shows 50 and the list shows 50, which is consistent
 * rather than a lie.
 */
export const PAGE_SIZE_STORAGE_KEY = toggleKey('table', 'rowsPerPage');
